import { Component } from 'react';

export class ContactGroupUsers extends Component {
    render () 
    {
        return (
            <ul>
                {this.props.users.map((user) => {
                    return <li key={user.userId}>
                        {user.name}
                    </li>
                })}                   
            </ul>               
        );
    }
}